import { render } from "./academicsdata.vue?vue&type=template&id=5293e124&scoped=true"
import script from "./academicsdata.vue?vue&type=script&lang=js"
export * from "./academicsdata.vue?vue&type=script&lang=js"

import "./academicsdata.vue?vue&type=style&index=0&id=5293e124&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5293e124"]])

export default __exports__